<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div>
        <el-select @change="enabledChange()" v-model="report.type">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="margin-top: 10px;">
      <el-table
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :data="reportsList"
          border
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="举报人" width="150">
          <template slot-scope="scope">
            <el-link type="primary" @click="getUserInfo(scope.row.userId)">{{ scope.row.reporterNickname }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="reason"
            label="原因"
            width="380">
        </el-table-column>
        <el-table-column
            prop="date"
            label="日期"
            width="150">
        </el-table-column>

        <el-table-column
            label="类型"
            width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.readed===0">
              <div v-if="scope.row.dynamicId!==0">
                <el-link type="primary" v-if="scope.row.type===0"
                         @click="dynamicDetail(scope.row.dynamicId,0,scope.row.id)">动态
                </el-link>
                <el-link type="warning" v-if="scope.row.type===1"
                         @click="dynamicDetail(scope.row.commentDynamicId,scope.row.dynamicId,scope.row.id)">评论
                </el-link>
              </div>
              <div v-if="scope.row.dynamicId===0">
                <el-link type="info" disabled>动态已被删除</el-link>
              </div>
            </div>
            <div v-if="scope.row.readed===1">
              <el-link type="info" disabled>已处理</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="处理\未处理"
            width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.readed===0">未处理</el-tag>
            <el-tag type="success" v-if="scope.row.readed===1">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <!--            <el-button @click="showEditMessage(scope.row)">编辑</el-button>-->
            <el-button type="danger" @click="deleteReport(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-button type="danger" size="small"
                   :disabled="this.multipleSelection.length===0"
                   @click="deleteMany">批量删除({{ this.multipleSelection.length }})
        </el-button>
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        :visible.sync="userDialogVisible"
        width="50%" style="min-width: 350px">
      <div v-if="userInfoLoading">
        <el-descriptions :colon="false">
          <el-descriptions-item :colon="false">
            <el-avatar :size="70" :src="userInfo.avatarUrl"></el-avatar>
          </el-descriptions-item>
          <!--          <el-descriptions-item label="用户名:">{{ userInfo.username }}</el-descriptions-item>-->
          <el-descriptions-item label="昵称:">{{ userInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="学校:">
            <el-tag size="small">{{ userInfo.schoolName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="认证信息:">
            {{ userInfo.intro }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="userDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        v-loading="dynamicLoading"
        :visible.sync="DialogVisible"
        @close="closeDynamicDetail()"
        width="600px" style="min-width: 350px">
      <div v-if="DialogVisible">

        <el-container style="padding-right:30px;">
          <el-header :height="40" style="text-align: left;padding-top: 10px;">
            <el-row>
              <el-col :span="2">
                <!-- 头像-->
                <div class="avatar-border">
                  <el-avatar v-if="dynamic.anonymity===0" :src="dynamic.avatarUrl"></el-avatar>
                  <el-avatar v-if="dynamic.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                  <div v-if="dynamic.anonymity===0">
                    <div v-if="dynamic.utype===2"
                         class="badge-gender" style="background-color:#FF6E40;">v
                    </div>
                    <div v-if="dynamic.utype===1"
                         class="badge-gender" style="background-color:#3688FF; ">v
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <!--昵称 时间 学校-->
                <div style="display: flow">
                  <div class="title-info">
                    {{ dynamic.nickname }}
                    <span v-if="dynamic.stick===1"
                          style="color:#EF5350;padding-left: 5px;">
                        [置顶]
                      </span>
                    <div style="font-size: 13px; ">
                      <div style="float: left;">
                        {{ dynamic.transformDate }}
                      </div>
                      <div style="color: #42A5F5; float: left; padding-left: 5px;">
                        {{ dynamic.schoolName }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-header>
          <el-main style="text-align: left;padding-top: 10px;padding-bottom: 10px;">
            <span v-if="dynamic.type!==1" style="word-break:break-word;" v-html='dynamic.content'></span>
            <div v-if="dynamic.type===1">
              <span>{{ JSON.parse(dynamic.content)[JSON.parse(dynamic.content).length - 1].content }}</span>
              <span style="word-break:break-word;" v-html='jsonToHtml(dynamic.content)'></span>
            </div>
            <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===0" style="padding-top: 10px;">
              <div v-if="dynamic.dynamicImgList.length!==4" style="width: 500px;display: inline;padding-left:5px;"
                   v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                <el-image
                    style="width: 150px; height: 150px"
                    :fit="cover"
                    :src="img.imgUrl"
                    :preview-src-list="imgList(dynamic.dynamicImgList)">
                </el-image>
              </div>
              <div v-if="dynamic.dynamicImgList.length===4 && dynamic.type===0"
                   style="width: 500px;display: inline;padding-left:5px;"
                   v-for="(img, indexImg) in dynamic.dynamicImgList" :key="indexImg">
                <el-image
                    style="width: 160px; height: 160px"
                    :fit="cover"
                    :src="img.imgUrl"
                    :preview-src-list="imgList(dynamic.dynamicImgList)">
                </el-image>
              </div>
            </div>
            <div v-if="dynamic.dynamicImgList.length>0 && dynamic.type===2">
              <Video v-bind:videoUrl="dynamic.dynamicImgList[0].imgUrl" :status="true"></Video>
            </div>
            <div v-if="dynamic.type===3" style="color: #E6A23C;">
              投票内容请在移动端查看
            </div>
            <!-- 圈子标签 -->
            <div style="padding-top: 10px;padding-bottom: 10px;" v-if="dynamic.circleType!==0">
              <!-- <gui-tags text="#边框标签" bgClass="gui-bg-white" color="#f75f00"
                  :width="0" :lineHeight="1.5" :size="28" :borderRadius="50" borderColor="#FF0035"></gui-tags> -->
              <div v-if="dynamic.circles!==null"
                   style="float: left;display:initial;height: 20px; border: #2196F3 solid 1px; font-size: 13px;color:#2196F3 ; border-radius: 50px;padding-left: 7px;padding-right: 7px;">
                {{ dynamic.circles.title }}
              </div>
            </div>
          </el-main>
          <el-footer :height="50"
                     style="text-align: center;padding-top: 5px;padding-bottom: 5px; border-top:solid #F6F7F8 2px;">
            <el-row>
              <el-col :span="8">
                {{ dynamic.praiseCount }} 赞
              </el-col>
              <el-col :span="8">{{ dynamic.commentCount }} 评论</el-col>
              <el-col :span="8" v-if="showComment===false">
                <span @click="deleteDynamic(dynamic.id,reportId)">
                  删除
                </span>
              </el-col>
            </el-row>
          </el-footer>
        </el-container>
        <div class="line"></div>
        <div v-if="showComment">
        <div style="text-align: left; border-bottom: #409EFF solid 2px; padding-top: 10px;width: 30px">
          评论
        </div>
        <div style="text-align: center;padding-top: 10px" v-if="commentList.length===0">
          暂无评论
        </div>
        <div v-if="commentList.length>0">
          <div v-for="(comment, index) in commentList" :key="index">
            <div :class="commentId ===comment.id ? 'border-red' : 'border-normal'">
              <el-container style="padding-right:30px;">
                <el-header :height="40" style="text-align: left;padding-top: 10px;">
                  <el-row>
                    <el-col :span="2">
                      <!-- 头像-->
                      <div class="avatar-border">
                        <el-avatar v-if="comment.anonymity===0" :src="comment.avatarUrl"></el-avatar>
                        <el-avatar v-if="comment.anonymity===1" icon="el-icon-user-solid"></el-avatar>
                        <div v-if="comment.anonymity===0">
                          <div v-if="comment.utype===2"
                               class="badge-gender" style="background-color:#FF6E40;">v
                          </div>
                          <div v-if="comment.utype===1"
                               class="badge-gender" style="background-color:#3688FF; ">v
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <!--昵称 时间 学校-->
                      <div style="display: flow">
                        <div class="title-info">
                          {{ comment.nickname }}
                          <div style="font-size: 13px; ">
                            <div style="float: left;">
                              {{ comment.transformDate }}
                            </div>
                            <div style="color: #42A5F5; float: left; padding-left: 5px;">
                              {{ comment.schoolName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-header>
                <el-main style="text-align: left;padding-top:1px;padding-left:65px;padding-bottom: 10px;">
                  <span style="word-break:break-word;" v-html='comment.content'></span>
                  <div v-if="comment.replyList.length>0"
                       style="background-color: #F2F6FC;border-radius: 10px;padding: 5px;">
                    <div v-for="(reply, index) in comment.replyList" :key="index">
                      <el-popover
                          placement="bottom"
                          width="100"
                          trigger="click">
                        <el-button type="danger" plain size="mini" @click="deleteReply(reply,reportId)">删除回复</el-button>
                        <div slot="reference">
                      <span style="color:#409EFF;">
                      {{ reply.fromNickname }}
                    </span>
                          <span v-if="reply.fromUserId!==reply.toUserId && reply.replyId!==0">回复@
                  <span style="color:#409EFF;">{{ reply.toNickname }}</span>
                  </span>
                          <sapn>: {{ reply.content }}</sapn>
                        </div>
                      </el-popover>
                    </div>
                  </div>
                </el-main>
                <div style="padding-bottom: 5px;text-align: right">
                  <el-button type="danger" plain size="mini" @click="deleteComment(comment,reportId)">删除评论</el-button>
                </div>

                <div style="border-top:solid #F6F7F8 2px;"></div>
              </el-container>
            </div>
          </div>
        </div>
      </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="DialogVisible = false">取 消</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ReportList",
  data() {
    return {
      options: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '已处理'
      }],
      reportsList: [],
      total: 0,
      multipleSelection: [],
      currentPage: 1,
      size: 10,
      userDialogVisible: false,
      userInfo: null,
      userInfoLoading: false,
      loading: false,
      report: {
        type: -1
      },
      DialogVisible: false,
      dynamic: null,
      dynamicLoading: false,
      commentId: 0,
      reportId: 0,
      commentList: [],
      showComment: false
    }
  },
  mounted() {
    this.commentList = []
    this.initReport()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    sizeChange(size) {
      this.size = size
      this.initReport()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initReport()
    },
    initReport() {
      this.loading = true
      this.postRequest('/report/list?currentPage=' + this.currentPage + '&size=' + this.size + '&type=' + this.report.type).then(resp => {
        if (resp) {
          this.reportsList = resp.data
          this.total = resp.total
          this.loading = false
        }
      })
    },
    getUserInfo(userId) {
      this.userDialogVisible = true
      this.postRequest('/message/web/userInfo?id=' + userId).then(resp => {
        if (resp) {
          this.userInfo = resp
        }
        this.userInfoLoading = true
      })
    },
    enabledChange() {
      this.initReport()
    },
    deleteReport(report) {
      this.$confirm('此操作将永久删除此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/report/' + report.id).then(resp => {
          if (resp) {
            this.initReport()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteMany() {
      this.$confirm('此操作将永久删除' + this.multipleSelection.length + '条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = '?'
        this.multipleSelection.forEach(item => {
          ids += 'ids=' + item.id + '&'
        })
        this.deleteRequest('/report/' + ids).then(resp => {
          if (resp) {
            this.initReport()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    jsonToHtml(content) {
      content = JSON.parse(content)
      console.log(content[1].content)
      var html = ''
      if (content.length > 0)
        content.forEach(item => {
          switch (item.type) {
            case "h3":
              html = html.concat('<h3>' + item.content + '</h3>')
              break;
            case "text":
              html = html.concat('<p>' + item.content + '</p>')
              break;

            case "txt":
              html = html.concat('<p>' + item.content + '</p>')
              break;
            case "code":
              html = html.concat('<pre>' + item.content + '</pre>')
              break;
            case "center":
              html = html.concat('<div style="text-align: center;">' + item.content + '</div>')
              break;
            case "quote":
              html = html.concat('<blockquote>' + item.content + '</blockquote>')
              break;
            case "strong":
              html = html.concat('<strong>' + item.content + '</strong>')
              break;
            case "link":
              html = html.concat('<p><a href="\'' + item.content + '" target="_blank">' + item['content'] + '</a><p>')
              break;
            case "spline":
              html = html.concat('<p><hr /><p>')
              break;
            case "img":
              html = html.concat('<img src=' + '"' + item.content + '" style="width:400px;"/>')
              break;
          }
        })
      return html
    },
    dynamicDetail(id, commentId, reportId) {
      this.reportId = reportId
      if (commentId === 0) {
        this.commentId = 0
      } else {
        this.commentId = commentId
        this.getCommentListByCommentId(commentId)
      }
      this.DialogVisible = true
      this.dynamic = null
      this.dynamicLoading = true
      this.postRequest('/dynamic/app/detail?id=' + id)
          .then(
              resp => {
                this.isLoad = true
                if (resp) {
                  //console.log(resp)
                  this.dynamicLoading = false
                  this.dynamic = resp
                  // this.dynamic.content = this.jsonToHtml(resp.content)
                }
              })
    },
    getCommentListByCommentId(commentId) {
      this.commentList = []
      this.getRequest('/report/web/comment?commentId=' + commentId).then(resp => {
        if (resp) {
          this.commentList = resp
          this.showComment = true
        }
      })
    },
    imgList(imgList) {
      var imgs = []
      for (var i = 0; i < imgList.length; i++) {
        imgs[i] = imgList[i].imgUrl
      }
      return imgs
    },
    deleteDynamic(id, reportId) {
      this.$confirm('此操作将永久删除此条动态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/report/web/?id=' + id + "&reportId=" + reportId).then(resp => {
          if (resp) {
            this.DialogVisible = false
            this.initReport()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteComment(comment, reportId) {
      this.$confirm('此操作将永久删除此条评论, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/report/web/comment/?id=' + comment.id + '&reportId=' + reportId).then(resp => {
          if (resp) {
            this.DialogVisible = false
            this.initReport()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteReply(reply, reportId) {
      this.$confirm('此操作将永久删除此条回复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/report/web/reply/?id=' + reply.id + "&reportId=" + reportId).then(resp => {
          if (resp) {
            this.DialogVisible = false
            this.initReport()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    closeDynamicDetail() {
      this.commentList = []
      this.showComment = false
    }
  }
}
</script>

<style scoped>
.infinite-list-wrapper {
  width: 600px;
  height: 700px;
  border: 1px solid #eee;
}

.avatar-border {
  width: 60px;
}

.title-info {
  /*width: 400px;*/
  text-align: left;
  word-break: break-word;
  padding-left: 5px;
}

/* 分割线 */
.line {
  height: 10px;
  background-color: #F6F7F8;
}

/* 徽章 */
.badge-gender {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  text-align: center;
  font-size: 15px;
  line-height: 15px;
  position: absolute;
  left: 25px;
  top: 23px;
  z-index: 1;
  border: #FFFFFF solid 2px;
  color: #FFFFFF;
}

.border-red {
  border: #F56C6C 1px solid;
  border-radius: 2px;
  box-shadow: 0 0 5px 2px #F56C6C;
}

.border-normal {

}
</style>
